import { render } from "./TransactionTagging.vue?vue&type=template&id=0e2873ec&scoped=true"
import script from "./TransactionTagging.vue?vue&type=script&lang=js"
export * from "./TransactionTagging.vue?vue&type=script&lang=js"

import "./TransactionTagging.vue?vue&type=style&index=0&id=0e2873ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2873ec"]])

export default __exports__